import { gql } from '@apollo/client'

export const GET_ALL_CONFIG_APP_PAGES = gql`
  query GetAllConfigAppPages($searchQuery: String, $limit: Int, $offset: Int) {
    getAllConfigAppPages(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      rows {
        id
        name
        description
        visible
        ElementsOfPage {
          id
        }
      }
      count
    }
  }
`

export const GET_ONE_CONFIG_APP_PAGES = gql`
  query GetOneConfigAppPage($id: Int!) {
    getOneConfigAppPage(id: $id) {
      id
      name
      description
      visible
    }
  }
`

export const CREATE_CONFIG_APP_PAGES = gql`
  mutation CreateConfigAppPage($input: ConfigAppPageInput!) {
    createConfigAppPage(input: $input)
  }
`

export const UPDATE_CONFIG_APP_PAGES = gql`
  mutation UpdateConfigAppPage(
    $input: ConfigAppPageInput!
    $configAppPageId: Int!
  ) {
    updateConfigAppPage(input: $input, configAppPageId: $configAppPageId)
  }
`

export const DELETE_CONFIG_APP_PAGES = gql`
  mutation DeleteConfigAppPage($id: Int!) {
    deleteConfigAppPage(id: $id)
  }
`
